type PauseDatesInput = {
  date_from: string | null | undefined
  date_to: string | null | undefined
}

/**
 * Валидация пауз расписания перед сохранением.
 * Пустой список пауз валиден; у каждой паузы должны быть обе даты и корректный порядок.
 * Возвращает ключ локализации ошибки или null.
 */
export function validateSchedulePauses(pauses: PauseDatesInput[]): string | null {
  for (const pause of pauses) {
    const from = (pause.date_from ?? '').slice(0, 10)
    const to = (pause.date_to ?? '').slice(0, 10)
    if (!from || !to) {
      return 'lessonSchedules.pauseDatesRequired'
    }
    if (to < from) {
      return 'lessonSchedules.pauseDatesOrderInvalid'
    }
  }
  return null
}
